import ReactMarkdown from 'react-markdown';
import { Typography } from '@mui/material';

const Markdown = (props) => {
    const { children, disabled } = props;

    return (
        <ReactMarkdown
            components={{
                p: ({ node, ...mdProps }) => (
                    <Typography
                        {...props}
                        {...mdProps}
                    />
                ),
                em: ({ node, ...mdProps }) => (
                    <span
                        style={{ color: '#0F428C', fontStyle: 'italic', fontWeight: 550 }}
                        {...props}
                        {...mdProps}
                    />
                ),
                strong: ({ node, ...mdProps }) => (
                    <span
                        style={{ color: disabled ? '#91cdfe' : '#014E8D', fontWeight: 550 }}
                        {...props}
                        {...mdProps}
                    />
                ),
                h3: ({ node, ...mdProps }) => (
                    <Typography
                        variant="h3"
                        style={{ color: '#014E8D', fontSize: '25px', fontWeight: 600, marginBottom: '1rem' }}
                        {...props}
                        {...mdProps}
                    />
                ),
            }}
        >
            {children}
        </ReactMarkdown>
    );
};

export default Markdown;
